/**
 * FE-C2g batch-8: User locations — contract paths for Home map people / responder layer.
 * Gate 4 MOB: consent / batch / on-call helpers for console soft desks (no native App).
 */

import { buildContractPath } from "./api/contract-client.js";

export const LOCATIONS_CONSOLE_TIMEOUT_MS = 8000;

/** @param {Record<string, string | number>} [query] */
export function buildLocationsLatestPath(query) {
  return buildContractPath("get__locations_latest", { query });
}

/** @param {Record<string, string | number>} [query] */
export function buildLocationsStreamPath(query) {
  return buildContractPath("get__locations_stream", { query });
}

export function buildLocationsConsentPostPath() {
  return buildContractPath("post__locations_consent");
}

export function buildLocationsConsentDeletePath() {
  return buildContractPath("delete__locations_consent");
}

/** CONV-0 consent roster (same visibility as latest). */
export function buildLocationsConsentsPath(query) {
  const q = query && typeof query === "object" ? query : {};
  const parts = [];
  if (q.include_revoked === true || q.include_revoked === 1 || q.include_revoked === "1") {
    parts.push("include_revoked=1");
  }
  if (q.limit != null && q.limit !== "") {
    parts.push(`limit=${encodeURIComponent(String(q.limit))}`);
  }
  const qs = parts.length ? `?${parts.join("&")}` : "";
  return `/locations/consents${qs}`;
}

export function buildLocationsBatchPath() {
  return buildContractPath("post__locations_batch");
}

export function buildLocationsOnCallGetPath() {
  return buildContractPath("get__locations_on-call");
}

export function buildLocationsOnCallPutPath() {
  return buildContractPath("put__locations_on-call");
}

/**
 * Shape one App-compatible GPS sample for console “share my pin” smoke.
 * @param {{ lat: number, lng: number, accuracyM?: number }} p
 */
export function buildPhoneLocationBatchBody(p) {
  const lat = Number(p && p.lat);
  const lng = Number(p && p.lng);
  const accuracy = Number((p && p.accuracyM) != null ? p.accuracyM : 25);
  const now = Date.now();
  return {
    items: [
      {
        latitude: lat,
        longitude: lng,
        accuracy_m: Number.isFinite(accuracy) ? accuracy : 25,
        recorded_at_ms: now,
        source: "phone",
      },
    ],
  };
}
